import React from 'react';

import { type UseFormReturn } from 'react-hook-form';

import { CURRENCIES } from 'src/features/payStations/types';
import ReservationNameTypeDate from 'src/features/reservations/components/forms/ReservationNameTypeDate';
import ReservationPricing from 'src/features/reservations/components/forms/ReservationPricing';
import ReservationStayDetails from 'src/features/reservations/components/forms/ReservationStayDetails';
import { type CreateReservationTypeFormSchemaValues } from 'src/features/reservations/hooks/useCreateReservationType';
import { useDisplayedFormValues } from 'src/features/reservations/providers/ReservationVersionsProvider';
import { formatPrice } from 'src/features/reservations/utils/utils';
import { Form } from 'src/registry/ui/Form';

interface VersionFormProps {
    form: UseFormReturn<CreateReservationTypeFormSchemaValues>;
    onSubmit: () => void;
}

function VersionForm({ form, onSubmit }: VersionFormProps) {
    const { setDisplayedFormValues } = useDisplayedFormValues();
    const { price, tax_amount, price_with_tax, tax_percent, currency, valid_from } = form.getValues();

    const [selectedFromDate, setSelectedFromDate] = React.useState<Date | undefined>(valid_from);

    React.useEffect(() => {
        setDisplayedFormValues({
            price: price ? formatPrice(price) : '',
            tax_percent: tax_percent ? (parseFloat(tax_percent) * 100).toFixed(2) : '',
            tax_amount: tax_amount ? formatPrice(tax_amount) : '',
            price_with_tax: price_with_tax ? formatPrice(price_with_tax) : '',
            currency: currency ?? CURRENCIES.EUR,
        });
    }, [form]);

    return (
        <Form form={form} variant="dialog" onSubmit={form.handleSubmit(onSubmit)}>
            <ReservationNameTypeDate selectedFromDate={selectedFromDate} setSelectedFromDate={setSelectedFromDate} />
            <ReservationPricing />
            <ReservationStayDetails />
        </Form>
    );
}

export { VersionForm };
